import { render, staticRenderFns } from "./FungicideStatistics.vue?vue&type=template&id=164618c0&"
import script from "./FungicideStatistics.vue?vue&type=script&lang=js&"
export * from "./FungicideStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports